import { Component, OnInit, inject } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthStateService } from '@core/auth/auth-state.service';
import { User } from '@core/models';
import { AlertService } from '@core/services/alert.service';
import { TranslocoDirective, translate } from '@jsverse/transloco';
import { ChangeProfilePictureDialogComponent } from '@main/common/change-profile-picture-dialog/change-profile-picture-dialog.component';
import { UserApiService } from '@main/user/services/user-api.service';
import { DialogRef, DialogService } from '@ngneat/dialog';

@Component({
    selector: 'app-change-profile',
    standalone: true,
    imports: [TranslocoDirective, ReactiveFormsModule, NgIf],
    templateUrl: './change-profile.component.html',
    styleUrl: './change-profile.component.scss',
})
export class ChangeProfileComponent implements OnInit {
    private dialogService = inject(DialogService);
    private authService = inject(AuthStateService);
    private userApiService = inject(UserApiService);
    private alertService = inject(AlertService);
    private location = inject(Location);
    dialogRef = inject(DialogRef, { optional: true });

    form = new FormGroup({
        firstName: new FormControl(this.authService.getUser()?.firstName),
        lastName: new FormControl(this.authService.getUser()?.lastName),
        username: new FormControl(),
    })
    message: string | undefined;

    ngOnInit() {
        this.userApiService.getMe().subscribe({
            next: (value) => {
                this.form.get('username')?.patchValue(value.displayName);
            },
        });
    }

    cancel () {
        this.location.back();
    }

    openProfilePictureModal () {
        this.dialogService.open(ChangeProfilePictureDialogComponent);
    }

    save () {
        if (this.form.invalid) {
            return;
        }

        const firstName = this.form.get('firstName')?.value ?? '';
        const lastName = this.form.get('lastName')?.value ?? '';
        const username = this.form.get('username')?.value ?? '';
        if(username.length < 3 || username.startsWith("user-")) {
            this.message = translate('profile.usernameInvalid');
            return
        }
        this.userApiService.changeProfile({ firstName, lastName, username }).subscribe({
            next: () => {
                this.authService.setUser({
                    ...this.authService.getUser(),
                    firstName,
                    lastName,
                    username: username || this.authService.getUser()?.username,
                } as User);
                this.alertService.success(translate('profile.updated'));
                this.dialogRef?.close();
            },
            error: (message) => {
                if (message.status == 409) {
                    this.message = translate('profile.usernameExists');
                }else {
                    this.alertService.error(translate('profile.updateError'));
                }
            },
        });
    }
}
